export const API = {
    AUTH: {
        LOGIN: '/auth/login',
        VERIFICATION: '/auth/accept-invitation',
        LOGOUT: '/user/logout',
        SEND_OTP: '/auth/send-otp',
        VERIFY_OTP: '/auth/verify-otp',
        RESET_PASSWORD: '/auth/reset-password',
        VERIFY_PASSWORD: '/auth/verify-password',
        SET_ONBOARD: '/auth/sign-up',
        SAVE_BASIC_DETAILS: '/auth/save-basic-details',
        GOOGLE_LOGIN: '/auth/google-login',
        FETCH_MICROSOFT_LOGIN: '/auth/microsoft-login/init',
        VERIFY_CODE: '/auth/microsoft-login/verify',
        WAL_CUSTOMERS: '/auth/wal/customers',
        WAL_SELECT: '/auth/wal/select',
    },
    ORGANIZATION: {
        MEMBERS: 'organization/members',
        INVITE_MEMBERS: 'organization/members-invite',
        UPDATE_MEMBER: 'organization/member-update',
        DELETE_MEMBER: 'organization/member-delete',
        STORE: '/organization/store',
    },
    CUSTOMER: {
        UPDATE_BUSINESS_PROFILE: '/customer/update-business-profile',
        GET_INDUSTRIES: '/industries/get',
        UPDATE_SHIPPING_NEEDS: '/customer/update-shipping-needs',
        ACTIVITIES: '/customer/activities',
        NOTIFICATION_SETTINGS: '/customer/notification-settings',
        TRACKING_NOTIFICATION_RECIPIENTS: '/customer/tracking-notification-recipients',
        // Shared tracking link document toggles (cp-meeting-changes F3)
        SHARED_LINK_DOCUMENTS: '/customer/shared-link-documents',
        REVIEW_ITEMS: '/customer/review-items',
        ACKNOWLEDGE_REVIEW_ITEM: '/customer/review-items/acknowledge',
        MARK_NOTIFICATION_SEEN: '/customer/notifications/mark-seen',
    },
    SETTING: {
        UPDATE: '/settings/update',
    },
    MEMBER: {
        MEMBER_LIST: 'member/member-list',
        MEMBER_EDIT: 'member/edit',
        MEMBER_DELETE: 'member',
        MEMBER_INVITE: 'member/invite',
    },
    SALES_DASHBOARD: {
        TEAM_LIST: 'sales/team-list',
    },
    USER: {
        GET: '/users/get-user-details',
        GET_DETAIL: '/user/get-detail',
        UPDATE_USER_DETAILS: '/users/update-user-details',
        UPDATE_WIDGET_SETTINGS: '/users/update-widget-settings',
        UPDATE_USER_SETTINGS: '/users/update-user-details',
    },
    QUOTE: {
        GET: '/quotes',
        GET_USER_QUOTES: '/user/quotes',
        LIST: '/quotes/list',
        CREATE: '/quotes/create',
        // Multi-stop submit (Task 8) — POST /quotes/multi-stop (3-5 stops); see
        // wal-customer-portal-be/src/controllers/quote/createMultiStopQuote.controller.ts
        MULTI_STOP: '/quotes/multi-stop',
        UPDATE: '/quotes/update',
        UPDATE_PICKUP_DATE: '/quotes/update-pickup-date',
        ACTIVE_QUOTE: '/quotes/active-quote',
        QUOTE_DETAIL: 'quote/quote-detail',
        UPDATE_STATUS: '/quote/status',
        BOOK_QUOTE: '/quotes/book-quote',
        LOAD_LINK: {
            GET_VEHICLE_TYPE: '/load-link/vehicle_type',
        },
        UPDATE_QUOTE_STATUS: 'quote/update-quote-status',
        UPLOAD_DOCUMENTS: '/quotes/upload-document',
        LIST_COUNT: '/quotes/list-count',
        ACTIVITIES: '/quotes', // used as /quotes/:quoteId/activities
        CUSTOMER_REQUEST: '/quotes/customer-request',
    },
    VIEW: {
        LIST: 'view/list',
        CREATE: '/view/create',
        UPDATE: '/view/update',
        DELETE: '/view/delete',
    },
    TABLE_COLUMN_SETTINGS: {
        UPDATE: '/table-column-settings/update',
        GET: '/table-column-settings/get',
    },
    COMMON: {
        INIT: '/common/init',
    },
    ROLE: {
        LIST: '/role',
    },
    HANDLING_UNIT: {
        LIST: '/handling-units/list',
    },
    SERVICES: {
        GET: '/services/get',
    },
    CURRENCY_RATE: {
        GET: '/currency/rate',
    },
    SHIPPER: {
        CONTACTS: {
            CREATE: '/address-book/create-shipper-contact',
            UPDATE: '/address-book/update-shipper-contact',
            DELETE: '/address-book/delete-shipper-contact',
        },
    },
    DASHBOARD: {
        UPCOMING: '/dashboard/get-orders-data',
        RECENT_ACTIVITY: '/dashboard/get-recent-activity',
    },
    ORDERS: {
        LIST: '/orders/list',
        GET_UNASSIGNED_ORDERS_BY_FILE: '/orders/get-unassigned-orders-by-file',
        LIST_COUNT: '/orders/get-orders-list-count',
        GET_ORDERS: '/orders/get-orders',
        GET_ORDER_BY_ID: '/orders',
        GET_ACTIVE_ORDER: '/orders/get-active-order',
        UPDATE_PRIORITY: '/orders/priority',
        SHARE_LINK_SUFFIX: '/share-link',
        TRACKING_RECIPIENTS_SUFFIX: '/tracking-notification-recipients',
        ORDER_NOTIFICATION_SETTINGS: '/orders/notification-settings',
        CUSTOMER_REQUEST: '/orders/customer-request',
        REQUEST_UPDATE_LOCATION: '/orders/request-update-location',
        SPECIAL_INSTRUCTIONS: '/orders/leg/special-instructions',
        LEG_NOTES: '/orders/leg/notes',
        LEG_UPLOAD_DOCUMENT: '/orders/leg/upload-document',
        LEG_DELETE_DOCUMENT: '/orders/leg/delete-document',
        SUMMARY: '/orders/summary',
        ORDER_FLOW_V2: {
            GET_ORDER_DETAILS: '/orders-v2/get-order-details',
            UPLOAD_CUSTOMS_DOCUMENTS: '/orders-v2/upload-customs-documents',
        },
    },
    ADDRESS_BOOK: {
        GET: '/address-book/get',
        CREATE: '/address-book/create',
        UPDATE: '/address-book/update',
        UPDATE_SINGLE: '/address-book/update-single',
        DELETE: '/address-book/delete',
        DELETE_SINGLE: '/address-book/delete-single',
        GET_SHIPPER_CONSIGNEE: '/address-book/get-shipper-consignee',
        IMPORT: '/address-book/import',
        IMPORT_TEMPLATE: '/address-book/import-template',
    },
    RADAR: {
        ORDER_SEND_CHAT_MESSAGE: '/radar/send-message',
        LIST_TRACKS: '/radar/list-orders',
    },

    TRACK: {
        ORDER_DETAIL: '/radar/order-detail',
    },

    EQUIPMENT: {
        TYPES: '/equipment/types',
    },
    LOADBOARD_COMMODITIES: {
        LIST: '/loadboard-commodities/list',
    },
    CHAT: {
        GET_MESSAGES: '/chat',
    },
    NOTIFICATION: {
        LIST: '/users/notifications',
        MARK_ALL_READ: '/users/notifications/mark-all-read',
    },
    DOCUMENTS: {
        INVOICES_LIST: '/documents/invoices/list',
        INVOICE_DETAIL: '/documents/invoices',
        POD_ORDER_CONTEXT: '/documents/pod-order-context', // used as /pod-order-context/:walOrderId
        TRACK_DOWNLOAD: '/documents/track-download', // portal usage: reports a file download (files are fetched from storage directly)
    },
    // Public share-link endpoints. The share token is sent in the
    // Authorization header by ShareLinkService — never the login JWT.
    SHARE_LINK: {
        GET_QUOTE: '/share-links/quote',
        GET_ACTIVE_QUOTE: '/share-links/quote/active',
        GET_ACTIVITIES: '/share-links/quote/activities',
        GET_MESSAGES: '/share-links/quote/messages',
        GET_ORDER: '/share-links/order',
        GET_ORDER_ACTIVITIES: '/share-links/order/activities',
        GET_RADAR_ORDER: '/share-links/radar-order',
        // Downloads of documents the customer chose to share; `/${documentId}` is appended
        ORDER_DOCUMENT: '/share-links/order/documents',
        RADAR_ORDER_DOCUMENT: '/share-links/radar-order/documents',
        GET_RADAR_ORDER_ACTIVITIES: '/share-links/radar-order/activities',
        GET_RADAR_ORDER_MESSAGES: '/share-links/radar-order/messages',
    },
    // Public WAL ID lookup behind track.westernalliancelogistics.com. No credential at all; the
    // backend rate-limits per IP and answers with the route plus a share token.
    PUBLIC_TRACKING: {
        LOOKUP: '/public-tracking',
    },
};
